import './about-info.scss';
import Grid from '@material-ui/core/Grid';
import aboutLogo from "../../assets/about/about-shawi.png";

export default function AboutInfo() {
  
    return (
      <div className="about-info">
        <Grid container >

          <Grid item xs={6} >
            <div className="who-we-are-about-info">
                <h3 className="shawi-title">مؤسسة الشيخ <br/> <span className="shikh-name">محمد بن صالح الشاوي</span> <br/> الخيرية</h3>
                <p className="shawi-description">مؤسسة خيرية مانحة ، مرخصة من وزارة الشؤون الاجتماعية برقم (54) ، تنطلق في عملها من خلال تبني ودعم المؤسسات الخيرية والجهات العاملة في الساحة بما يتوافق مع المجالات التي حددها فضيلة الشيخ محمد بن صالح الشاوي حفظه الله.</p>
            </div>
          </Grid>

          <Grid item xs={6} >

            <div className="who-we-are-about-image">
                    <img alt="logo-alshawi" src={aboutLogo} className="our-about-img" />
            </div>
         
          </Grid>
        </Grid>
      </div>
    );
  }